"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePropertyDetailsBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var AnnualHomePropertyDetailsBanner = /** @class */ (function (_super) {
    __extends(AnnualHomePropertyDetailsBanner, _super);
    function AnnualHomePropertyDetailsBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToEditPropertyDetailsJourney = function () {
            journey_services_1.ObjectManipulator.setField("uistate.subprocess", _this.props.interaction, "changePropertyDetails");
            _this.props.engine.navigate("propertyDetails", false);
        };
        return _this;
    }
    AnnualHomePropertyDetailsBanner.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "banner banner-info", children: (0, jsx_runtime_1.jsxs)("p", { children: ["Please", ' ', (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)("button", { className: "btn-text", onClick: this.navigateToEditPropertyDetailsJourney, disabled: this.props.disabledHyperlink, children: "tell us" }) }), ' ', "if your property undergoes structural renovations."] }) }));
    };
    return AnnualHomePropertyDetailsBanner;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomePropertyDetailsBanner = AnnualHomePropertyDetailsBanner;
//# sourceMappingURL=AnnualHomePropertyDetailsBanner.js.map